module.exports = __webpack_public_path__ + "static/media/janaeGoodrich.8a789437.jpg";